import { FileJson, ShoppingBag, Building2, HelpCircle, FileText, Calendar } from "lucide-react";
import { useLanguage } from "@/lib/i18n/LanguageContext";

export const EmptyState = () => {
  const { t } = useLanguage();

  const schemaTypes = [
    { icon: ShoppingBag, ...t.schemaTypes.product },
    { icon: Building2, ...t.schemaTypes.organization },
    { icon: HelpCircle, ...t.schemaTypes.faq },
    { icon: FileText, ...t.schemaTypes.article },
    { icon: Calendar, ...t.schemaTypes.event },
    { icon: FileJson, ...t.schemaTypes.breadcrumb },
  ];

  return (
    <div className="text-center py-16 space-y-8">
      <div className="space-y-3">
        <h2 className="text-xl font-semibold text-foreground">
          {t.emptyState.title}
        </h2>
        <p className="text-muted-foreground max-w-md mx-auto">
          {t.emptyState.description}
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-2xl mx-auto">
        {schemaTypes.map(({ icon: Icon, label, desc }) => (
          <div
            key={label}
            className="p-4 bg-secondary/30 border border-border/50 rounded-xl hover:border-primary/30 transition-colors group"
          >
            <Icon className="w-6 h-6 text-muted-foreground group-hover:text-primary transition-colors mx-auto mb-2" />
            <p className="font-medium text-foreground text-sm">{label}</p>
            <p className="text-xs text-muted-foreground">{desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
